import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Alert, AlertDescription } from '../components/ui/alert';
import { Button } from '../components/ui/button';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    
    if (!token) {
      setStatus('error');
      setMessage('Invalid verification link. Missing token.');
      return;
    }

    verifyEmail(token);
  }, [searchParams]);

  const verifyEmail = async (token) => {
    try {
      await axios.post(`${API}/auth/verify-email`, { token });
      setStatus('success');
      setMessage('Your email has been successfully verified!');
      setTimeout(() => navigate('/login'), 3000);
    } catch (err) {
      setStatus('error');
      setMessage(err.response?.data?.detail || 'Email verification failed. The link may be invalid or expired.');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#005DAA] to-[#0077CC] p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-block bg-white rounded-lg p-4 shadow-lg mb-4">
            <img src="/logo_6270.png" alt="Rotary District 6270" className="h-24 w-auto" />
          </div>
        </div>

        <Card className="card-shadow">
          <CardHeader>
            <CardTitle data-testid="verify-title">
              {status === 'loading' && 'Verifying Email...'}
              {status === 'success' && 'Email Verified!'}
              {status === 'error' && 'Verification Failed'}
            </CardTitle>
          </CardHeader>
          <CardContent>
            {status === 'loading' && (
              <div className="text-center py-8">
                <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-[#005DAA]"></div>
                <p className="mt-4 text-gray-600">Please wait while we verify your email...</p>
              </div>
            )}

            {status === 'success' && (
              <Alert className="bg-green-50 border-green-200 alert-animate" data-testid="success-alert">
                <AlertDescription className="text-green-800">
                  {message}
                  <br />
                  <span className="text-sm">Redirecting to login page...</span>
                </AlertDescription>
              </Alert>
            )}

            {status === 'error' && (
              <div>
                <Alert className="mb-4 bg-red-50 border-red-200 alert-animate" data-testid="error-alert">
                  <AlertDescription className="text-red-800">{message}</AlertDescription>
                </Alert>
                <div className="space-y-2">
                  <Button
                    onClick={() => navigate('/register')}
                    className="w-full"
                    variant="outline"
                    data-testid="back-to-register-button"
                  >
                    Back to Registration
                  </Button>
                  <Link to="/login" className="block text-center text-sm text-[#005DAA] hover:underline" data-testid="login-link">
                    Already verified? Sign in here
                  </Link>
                </div>
              </div>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  );
}

export default VerifyEmail;
